export default {
	'salary-details': 'Salary Details',
	'received-salary': 'Received Salary',
	'receiving-date': 'Receiving Date',
	'base-salary': 'Base Salary',
	rewards: 'Rewards',
	rebates: 'Rebates',
	transportation: 'Transportation',
	'liability-compensation': 'Liability Compensation',
	'living-expenses': 'Living Expenses',
	communications: 'Communications',

	'add-new-vacation-request': 'Add New Vacation Request',
	'vacation-type': {
		'sick-leave': 'Sick leave',
		'unpaid-leave': 'Unpaid leave',
		'paid-leave': 'Paid leave',
	},
	'the-request-is-sent': 'The Request is sent',

	'add-new-administrative-request': 'Add New Administrative Request',
	'administrative-type': {
		'administrative-day': 'Administrative Day',
		'half-administrative-day': 'Half Administrative Day',
	},

	administrative: 'Administrative',
	leaves: 'Leaves',
	salary: 'Salary',
	visits: 'Visits',
	'financial-target': 'Financial Target',
	'today-visits': 'Today\'s Visits',
	'today-income': 'Today\'s income',
	'you-have-completed-$-out-of-$': 'You have completed {num1} out of {num2}',
	'last-rating': 'Last Rating',
	'leaves-remaining': 'Leaves Remaining'
}